import "../../../../styles/page/help&support.scss";

import { TitleTab, TitleTabs } from "../../../common/components/TitleTabs";

import ContentWrapper from "../../../common/components/ContentWrapper.jsx";
import FaqCard from "./FaqCard.jsx";
import { Localization } from "../../../common/util/localization.jsx";
import MessageCart from "./MessageCart";
import PropTypes from "prop-types";
import React from "react";
import { scssVariables } from "../../../common/util/config";

class HelpFaqPage extends React.PureComponent {
    constructor(props){
        super(props);

        this.calculateMessageCardHeight = this.calculateMessageCardHeight.bind(this);
        this.calculateMessageCartHeight = this.calculateMessageCartHeight.bind(this);
    }

    UNSAFE_componentWillMount() {
        if (this.props.faq.length === 0)
            this.props.getFaq();
    }

    calculateMessageCardHeight() {
        const {
            deviceType,
            height,
        } = this.props;
        let productDisplayHeight = height;
        
        //page padding
        productDisplayHeight -= parseInt(scssVariables[`${deviceType}ContentPadding`])*2;

        if( deviceType==="xs" ) {
            //shopping cart in menu form
            productDisplayHeight -= parseInt(scssVariables.menuHeightWithBorder);
        } else {
            //title tabs
            productDisplayHeight -= parseInt(scssVariables.titleTabHeight);
        }
        //product display margin
        productDisplayHeight -= parseInt(scssVariables.cardMargin)*2;

        return productDisplayHeight;
    }
    calculateMessageCartHeight() {
        const {
            deviceType,
            height,
        } = this.props;
        let productDisplayHeight = height;
        
        //page padding
        productDisplayHeight -= parseInt(scssVariables[`${deviceType}ContentPadding`])*2;
        //product display margin
        productDisplayHeight -= parseInt(scssVariables.cardMargin)*2;

        return productDisplayHeight;
    }

    render(){
        const {
            deviceType,
            localization,
            height,
            width,
            editMessage,
            support,
            message,
            faq,
            clearMessage,
            submitSupportMessage,
            setDropDown,
        } = this.props;
        const messageCartHeight = this.calculateMessageCartHeight();
        const cardHeight = this.calculateMessageCardHeight();

        const isTinyDevice = deviceType=="xs" || deviceType=="sm";

        return deviceType=="xs" ? (
            <ContentWrapper height={height}>
                <div className="my-list-left-backgorund" >
                    <FaqCard 
                        localization={localization} 
                        height={cardHeight}
                        faq={faq}
                    />
                    <MessageCart
                        localization={localization}
                        height={messageCartHeight}
                        deviceType={deviceType}
                        width={width}
                        editMessage={editMessage}
                        faq={faq}
                        support={support}
                        message={message}
                        clearMessage={clearMessage}
                        submitSupportMessage={submitSupportMessage}
                        setDropDown={setDropDown}
                    />
                </div>
            </ContentWrapper>
        ) : (
            <ContentWrapper height={height} paddingRight={false}>
                <div style={{display:"flex", height:"100%"}} >
                    <div className="my-list-left-backgorund" >
                        <TitleTabs>
                            <TitleTab label={localization.text("help","titleTab","faq")} url={"/help/faq"} deviceType={deviceType} />
                        </TitleTabs>
                        <FaqCard 
                            localization={localization} 
                            height={cardHeight}
                            faq={faq}
                        />
                    </div>
                    <div style={{height:"100%", flex: `0 0 ${isTinyDevice ? scssVariables.shoppingCartWidthTiny : scssVariables.shoppingCartWidth}`}} >
                        <MessageCart
                            localization={localization}
                            height={messageCartHeight}
                            width={width}
                            deviceType={deviceType}
                            editMessage={editMessage}
                            faq={faq}
                            support={support}
                            message={message}
                            clearMessage={clearMessage}
                            submitSupportMessage={submitSupportMessage}
                            setDropDown={setDropDown}
                        />
                    </div>
                </div>
            </ContentWrapper>
        );
    }
}

HelpFaqPage.propTypes = {
    deviceType: PropTypes.string.isRequired,
    localization: Localization.propTypes.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    editMessage: PropTypes.func.isRequired,
    support: PropTypes.object.isRequired,
    message: PropTypes.object.isRequired,
    getFaq: PropTypes.func.isRequired,
    faq: PropTypes.array.isRequired,
    clearMessage: PropTypes.func.isRequired,
    submitSupportMessage: PropTypes.func.isRequired,
    setDropDown: PropTypes.func.isRequired,
};

export default HelpFaqPage;
